(function () {
  "use strict";

  /* ---------- scroll reveal ---------- */
  function initReveal(scope) {
    var root = scope || document;
    var revealEls = root.querySelectorAll(".dfuse-reveal");
    if (!revealEls.length) return;
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("in");
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add("in"); });
    }
  }

  /* ---------- scent tabs (per scent-tabs section instance) ----------
     Real ARIA tablist: role="tab"/"tabpanel", aria-selected, roving
     tabindex, and Left/Right/Home/End keyboard navigation between tabs.
     Deep-link-by-hash is intentionally not supported: with real product
     pages #scent-<name> URLs no longer exist, and pushing history state on
     every tab click would pollute the back button. */
  function initScentTabs(scope) {
    var root0 = scope || document;
    root0.querySelectorAll("[data-dfuse-scent-tabs]").forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll(".dfuse-scent-tab"));
      var panels = Array.prototype.slice.call(root.querySelectorAll(".dfuse-scent-panel"));
      if (!tabs.length) return;

      function activate(name, opts) {
        opts = opts || {};
        var activePanel = null;
        tabs.forEach(function (t) {
          var on = t.getAttribute("data-scent") === name;
          t.setAttribute("data-active", String(on));
          t.setAttribute("aria-selected", String(on));
          t.setAttribute("tabindex", on ? "0" : "-1");
          if (on && opts.focus) t.focus();
        });
        panels.forEach(function (p) {
          var on = p.getAttribute("data-panel") === name;
          p.setAttribute("data-active", String(on));
          if (on) {
            p.removeAttribute("hidden");
            activePanel = p;
          } else {
            p.setAttribute("hidden", "");
          }
        });
        if (opts.scroll && activePanel) {
          var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          activePanel.scrollIntoView({
            behavior: reduceMotion ? "auto" : "smooth",
            block: "nearest",
          });
        }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener("click", function () {
          activate(tab.getAttribute("data-scent"), { scroll: true });
        });
        tab.addEventListener("keydown", function (e) {
          var next = null;
          if (e.key === "ArrowRight") next = tabs[(i + 1) % tabs.length];
          else if (e.key === "ArrowLeft") next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === "Home") next = tabs[0];
          else if (e.key === "End") next = tabs[tabs.length - 1];
          if (next) {
            e.preventDefault();
            activate(next.getAttribute("data-scent"), { focus: true, scroll: true });
          }
        });
      });
    });
  }

  /* ---------- lightbox (single global instance, lives in layout/theme.liquid
     so it is never re-rendered by shopify:section:load) + hero zoom trigger.
     lastTrigger/lightboxBound live at module scope, not inside initGalleries,
     so that (a) focus-return works no matter which section-load call wired
     up a given trigger, and (b) the global close/backdrop/Escape listeners
     are only ever attached once even though initGalleries runs again on
     every section re-render. */
  var lightboxBound = false;
  var lastTrigger = null;

  function initGalleries(scope) {
    var root = scope || document;
    var lightbox = document.getElementById("dfuseLightbox");
    var lightboxContent = document.getElementById("dfuseLightboxContent");

    function openLightbox(html, trigger) {
      if (!lightbox) return;
      lastTrigger = trigger || null;
      lightboxContent.innerHTML = html;
      lightbox.classList.add("open");
      lightbox.setAttribute("aria-hidden", "false");
      var closeBtn = document.getElementById("dfuseLightboxClose");
      if (closeBtn) closeBtn.focus();
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove("open");
      lightbox.setAttribute("aria-hidden", "true");
      lightboxContent.innerHTML = "";
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    }

    if (lightbox && !lightboxBound) {
      lightboxBound = true;
      var closeBtn = document.getElementById("dfuseLightboxClose");
      if (closeBtn) closeBtn.addEventListener("click", closeLightbox);
      lightbox.addEventListener("click", function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeLightbox();
      });
    }

    root.querySelectorAll(".dfuse-hero-zoom").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        var img = trigger.querySelector("img");
        if (img) openLightbox(img.outerHTML, trigger);
      });
    });
  }

  /* ---------- hero load sequence ----------
     Gates the one-time load-reveal animation (dfuse-theme.css) behind
     .dfuse-hero-stage.is-loaded so the image never pops in unstyled. The
     error handler matters: without it a broken image would leave the stage
     permanently at opacity: 0. */
  function initHero(scope) {
    var root = scope || document;
    root.querySelectorAll(".dfuse-hero-stage").forEach(function (stage) {
      var img = stage.querySelector("img");
      if (!img) { stage.classList.add("is-loaded"); return; }
      if (img.complete) { stage.classList.add("is-loaded"); return; }
      img.addEventListener("load", function () { stage.classList.add("is-loaded"); }, { once: true });
      img.addEventListener("error", function () { stage.classList.add("is-loaded"); }, { once: true });
    });
  }

  function initAll(scope) {
    initReveal(scope);
    initScentTabs(scope);
    initGalleries(scope);
    initHero(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
